import { apiClient } from './apiClient';
import { StakeSnapshot } from '../types/stakeSnapshot';

type PaginatedResponse<T> = {
  data: T[];
};

export async function listStakeSnapshots(token: string) {
  return apiClient<PaginatedResponse<StakeSnapshot>>('/stake-snapshots', {
    method: 'GET',
    token,
  });
}

type StakeSnapshotPayload = {
  effective_date: string;
  gaurav_pct: number;
  sourabh_pct: number;
  company_pct: number;
  note?: string | null;
};

export async function createStakeSnapshot(token: string, payload: StakeSnapshotPayload) {
  return apiClient<{ data: StakeSnapshot }>('/stake-snapshots', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });
}

export async function updateStakeSnapshot(token: string, id: number, payload: StakeSnapshotPayload) {
  return apiClient<{ data: StakeSnapshot }>(`/stake-snapshots/${id}`, {
    method: 'PUT',
    token,
    body: JSON.stringify(payload),
  });
}

export async function deleteStakeSnapshot(token: string, id: number) {
  return apiClient<{ message: string }>(`/stake-snapshots/${id}`, {
    method: 'DELETE',
    token,
  });
}

